import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section
      style={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px"
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "700px"
        }}
      >
        <h1
          style={{
            fontSize: "6rem",
            color: "#002147",
            marginBottom: "20px"
          }}
        >
          404
        </h1>

        <h2
          style={{
            color: "#002147",
            marginBottom: "20px"
          }}
        >
          Page Not Found
        </h2>

        <p
          style={{
            color: "#6e6e73",
            lineHeight: 1.8,
            marginBottom: "30px"
          }}
        >
          The page you are looking for does not
          exist or may have been moved.
        </p>

        <Link
          to="/"
          className="btn btn-success"
        >
          Back To Home
        </Link>
      </div>
    </section>
  );
}

export default NotFound;